import React from "react";
import { Col, Row } from "react-bootstrap";
import Calendario from "../atoms/Calendario";
import styled from "styled-components";
import { useState } from "react";
import { Link } from "gatsby";
import { useAlert } from "react-alert";
import { REGEX } from "../../constants/index/index";

const FormRegister = () => {
	const [date, setDate] = useState(new Date());
	const [errors, setErrors] = useState({});
	const alert = useAlert();

	const [registerDetail, setRegisterDetail] = useState({
		nombre: "",
		apellido_materno: "",
		estado_civil: "",
		nacionalidad: "",
		date,
		genero: "1",
		rfc: "",
		homoclave: "",
		correo: "",
		contrasena: "",
	});

	const Submit = () => {
		const { nombre, apellido_materno } = registerDetail;

		if (nombre.length !== 0 && apellido_materno.length !== 0) {
			if (REGEX["text"].test(nombre) && REGEX["text"].test(apellido_materno)) {
				// submission
				setErrors({});
			} else {
				if (!REGEX["text"].test(nombre)) {
					setErrors({ ...errors, ...{ nombre: true } });
					return alert.show("Este campo sólo admite letras");
				}
				if (!REGEX["text"].test(apellido_materno)) {
					setErrors({ ...errors, ...{ apellido_materno: true } });
					return alert.show("Este campo sólo admite letras");
				}
			}
			return;
		}
		let ERR = {};
		if (nombre.length == 0) {
			ERR = { ...ERR, nombre: true };
		} else {
			let newErr = errors;
			delete newErr["nombre"];
			setErrors(newErr);
		}
		if (apellido_materno.length == 0) {
			ERR = { ...ERR, apellido_materno: true };
		} else {
			let newErr = errors;
			delete newErr["apellido_materno"];
			setErrors(newErr);
		}

		setErrors({ ...errors, ...ERR });
		alert.show("Por favor complete todos los campos");
	};
	const handleInput = (e) => {
		const name = e.target.name;
		const value = e.target.value;

		setRegisterDetail({ ...registerDetail, [name]: value });
	};

	return (
		<div className='card'>
			<div className='card-body px-4 px-md-5'>
				<Row>
					<Col sm={12}>
						<label className='form-label'>Nombre(s)*</label>
						<input
							value={registerDetail?.nombre}
							onChange={handleInput}
							name='nombre'
							style={errors?.nombre ? { borderColor: "red" } : {}}
							type='text'
							className='form-control'
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<label className='form-label'>Apellido Materno*</label>
						<input
							name='apellido_materno'
							onChange={handleInput}
							value={registerDetail?.apellido_materno}
							style={errors?.apellido_materno ? { borderColor: "red" } : {}}
							type='text'
							className='form-control'
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<label className='form-label'>Estado Civil</label>
						<select className='form-control'>
							<option selected={true}>Estado Civil</option>
							<option>Soltero(a)</option>
							<option>Casado(a)</option>
							<option>Divorsiado(a)</option>
							<option>Viudo(a)</option>
						</select>
					</Col>
					<Col sm={12} md={6}>
						<label className='form-label d-block'>Nacionalidad</label>
						<div className='custom-radio d-inline-block'>
							<input type='radio' id='Mexicana' name='Otro' checked />
							<label htmlFor='Mexicana'>Mexicana</label>
						</div>
						<div className='custom-radio d-inline-block ml-4'>
							<input type='radio' id='Otro' name='Otro' />
							<label htmlFor='Otro'>Otro</label>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<label className='form-label'>Fecha de Nacimiento</label>
						<Calendario
							value={date}
							handleChange={(newDate) => setDate(newDate)}
						/>
					</Col>
					<Col sm={12} md={6}>
						<label className='form-label d-block'>Género</label>
						<div className='custom-radio d-inline-block'>
							<input type='radio' id='fem' name='gender' />
							<label htmlFor='fem'>Femenino</label>
						</div>
						<div className='custom-radio d-inline-block ml-4'>
							<input type='radio' id='masc' name='gender' checked />
							<label htmlFor='masc'>Masculino</label>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<label className='form-label'>R.F.C.*</label>
						<input type='text' className='form-control' />
					</Col>
					<Col sm={12} md={6}>
						<label className='form-label'>Homoclave*</label>
						<input type='text' className='form-control' />
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<label className='form-label'>Correo</label>
						<input type='text' className='form-control' />
					</Col>
					<Col sm={12} md={6}>
						<label className='form-label'>Contraseña</label>
						<input type='password' className='form-control' />
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<div className='form-group custom-checkbox mb-0'>
							<input type='checkbox' id='acepto' />
							<label htmlFor='acepto'>
								He leído y acepto los{" "}
								<Link to='/terminos'>
									términos y condiciones de bajatuseguro{" "}
								</Link>{" "}
								.
							</label>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<div className='form-group custom-checkbox'>
							<input type='checkbox' id='Privacidad' />
							<label htmlFor='Privacidad'>
								He leído y estoy de acuerdo con el{" "}
								<Link to='/privacy-policy'>Aviso de Privacidad</Link>.
							</label>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12} className='text-center'>
						<Button onClick={Submit}>Registrarme</Button>
						<p className='mb-0'>
							<a href='#'>Ya tengo una cuenta</a>
						</p>
					</Col>
				</Row>
			</div>
		</div>
	);
};

const Button = styled.button`
	background: #f89900;
	border: 3px solid white;
	color: white;
	text-align: center;

	padding: 11px;
	border-radius: 100px;
	width: 200px;
	margin-top: 10%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 7%;
`;
export default FormRegister;
